"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeModal = exports.openModal = exports.handleButtonClick = void 0;
function handleButtonClick(event) {
    if (this.isModalOpen()) {
        this.closeModal();
        this.fire('close', { Modal: this });
    }
    else {
        this.openModal();
        this.fire('open', { Modal: this });
    }
}
exports.handleButtonClick = handleButtonClick;
function openModal() {
    if (!this.isModalOpen()) {
        this.modal.classList.add('open');
        if (this.config.attributes) {
            this.modal.setAttribute('open', '');
        }
        this.backdrop.showBackdrop();
        this.modal.dispatchEvent(new CustomEvent('wr-modal-shown', {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
        document.body.dispatchEvent(new CustomEvent('wr-modal-shown', {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
    }
}
exports.openModal = openModal;
function closeModal() {
    if (this.isModalOpen()) {
        this.modal.classList.remove('open');
        if (this.config.attributes) {
            this.modal.removeAttribute('open');
        }
        this.backdrop.fire('hide');
        this.modal.dispatchEvent(new CustomEvent('wr-modal-hidden', {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
        document.body.dispatchEvent(new CustomEvent('wr-modal-hidden', {
            detail: {
                element: this.modal,
                backdrop: this.backdrop,
                modal: this
            }
        }));
    }
}
exports.closeModal = closeModal;
//# sourceMappingURL=eventHandlers.js.map